import React from "react";
import { Box, Typography } from "@mui/material";

interface ProgressPieNumberProp {
  num: number;
}

export default function ProgressPieNumber({ num }: ProgressPieNumberProp) {
  return (
    <Box
      sx={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Typography sx={{ fontSize: 14, color: "#747474" }}>{num}</Typography>
    </Box>
  );
}
